import React, {useState, useEffect} from 'react';
import Image1 from '../../assest/herobanner1.jpeg';
import Image2 from '../../assest/herobanner2.jpeg';
import Image3 from '../../assest/herobanner3.jpeg';
import Image4 from '../../assest/herobanner4.jpeg';
import Image5 from '../../assest/herobanner5.jpeg';
import Image6 from '../../assest/herobanner6.jpeg';
import './herobanner.scss'

const images = [Image1, Image2, Image3, Image4, Image5, Image6];

const Herobanner = ({ onViewClick }) =>
{
	
	
	const [currentIndex, setCurrentIndex] = useState(0);
	
	
	useEffect(() => {
		const interval = setInterval(() => {
			setCurrentIndex((prevIndex) =>
				prevIndex === images.length - 1 ? 0 : prevIndex + 1
			);
		}, 4000); // change every 3 sec
		
		return () => clearInterval(interval);
	}, []);
	
	return (
		<>
			<div className="mainHerobanner">
				<div className="subHerobanner"
				     style={{
					     backgroundImage: `url(${images[currentIndex]})`
				     }}
				>

					<div className="Herobanner">
						<h1>Find Your<span> Perfect  </span> Stay</h1>
						<p>Explore handpicked stays designed for comfort, style, and unforgettable experiences.</p>

						<div className="HeroBtn">
							{/* <button className="Btn1" onClick={onViewClick}>View Properties</button> */}
							<button className="Btn1" onClick={onViewClick}>View Properties</button>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default Herobanner;